import React, { useEffect, useRef  }  from 'react';
import classes from './Hero.module.scss';
import { getFileName } from 'helpers/FileCaching';
import globalJson from 'data/content.json';
import ScrollMagic from 'scrollmagic';
import TimelineMax from "gsap/TimelineMax";
import { TweenMax, Power3, TimelineLite} from 'gsap';
// import { userInfo } from 'os';

const heroImages = require.context('assets/images/Hero', true, /.*\.(gif|png|jpe?g|svg)$/i);
const iconsImages = require.context('assets/images/global/icons', true, /.*\.(gif|png|jpe?g|svg)$/i);
const Hero = (props) => {

    let heroContainer = useRef();
    let starsMove = useRef();
    let worldMove = useRef();
    let title = useRef();
    let subTitle = useRef();
    let description = useRef();
    let oval = useRef();
    let allScroll = useRef();

    let scrollMagicController = useRef();
    let scrollMagicScene = useRef();

    let hero_tl = useRef(new TimelineLite({paused:true}));
    let stars_tl = useRef(new TimelineLite({paused:true}));
    let oval_tl = useRef(new TimelineMax({paused:true}));//, repeat: -1
    // oval_tl.current.timeScale(2);

  
    const configureScrollMagic = () => {
        //Configure scroll magic
        scrollMagicController.current = new ScrollMagic.Controller()
        scrollMagicScene.current = new ScrollMagic.Scene({
                                        triggerHook:0.7
                                    }).addTo(scrollMagicController.current)
        scrollMagicScene.current.triggerElement(heroContainer.current);
        scrollMagicScene.current.duration((600));
        scrollMagicScene.current.triggerHook('0');
        // scrollMagicScene.current.reverse(false);
        scrollMagicScene.current.on("progress", function(event){
            updateTimeline(event.progress);
        })
    }


    const createTimeline = () => {
            TweenMax.set(worldMove.current,{opacity:0, y: 90})
            TweenMax.set(starsMove.current,{opacity:0, y: -30})
            TweenMax.set(oval.current,{opacity:0})
            TweenMax.set([allScroll.current, title.current, subTitle.current, description.current],{opacity:0})
        
            hero_tl.current.to(starsMove.current, 0.5 , {delay: 0.5, opacity:1, ease: Power3.easeOut, onStart:movingStars});
            hero_tl.current.to(worldMove.current, .8 , {delay: 0, y:-5, opacity:1, ease: Power3.easeOut });
            hero_tl.current.to(title.current, .8,{delay: -.5, y:-10, opacity:1, ease: Power3.easeOut});
            hero_tl.current.to(subTitle.current, .5, {delay: -0.6, y:-10, opacity:1, ease: Power3.easeOut});
            hero_tl.current.to(description.current, .5,{delay: -0.6, y:-10, opacity:1, ease: Power3.easeOut});
            hero_tl.current.to(allScroll.current, 1,{delay: -0.6, opacity:1, ease: Power3.easeOut});
            hero_tl.current.to(oval.current, 1,{delay: -0.6, opacity:1, ease: Power3.easeOut});
            hero_tl.current.play();

            stars_tl.current.to(starsMove.current, 20, {delay: -0.5, y:-140});
            oval_tl.current.fromTo(oval.current, .5,{ top:0},{ top:90});
        
    }

    const updateTimeline = (progress) => {
        let timelineLength = oval_tl.current.duration();
        let tweenToSeconds = timelineLength*progress
        oval_tl.current.tweenTo(tweenToSeconds);
    }
        
    const movingStars = () =>{
        stars_tl.current.play();
    }

    useEffect(() => {
        createTimeline();
        configureScrollMagic();
      
    }, []);

   return (
    <div ref={heroContainer} className={classes.Hero}>
        <div ref={starsMove} className={classes.Hero__stars}
            style={
                {
                    backgroundImage: 'url(' + getFileName(heroImages, 'Stars-BG.jpg') + ')'
                }
            }>
        </div>
        <div className={`col-md-8 col-lg-8 col-xl-6 ${classes.Hero__content}`}>
            <h1 ref={title} className= {classes.Hero__title} dangerouslySetInnerHTML={{__html:globalJson.hero.title}}></h1>
            <h4 ref={subTitle} className= {classes.Hero__subTitle}>{globalJson.hero.subTitle}</h4>
            <p ref={description} className= {classes.Hero__description}>{globalJson.hero.description}</p>
        </div>
        <div ref={worldMove} className={classes.Hero__world}
            style={
                {
                    backgroundImage: 'url(' + getFileName(heroImages, 'World-min.png') + ')'
                }
            }>
        </div>
        <div className={`scroll-container`}>
            <div className="container">
                <div ref={allScroll} className={`scroll-me`}>
                    <div  className={`scroll-down-copy`}
                        style={
                            {
                                backgroundImage: 'url(' + getFileName(iconsImages, 'scroll_copy.svg') + ')'
                            }
                        }>
                    </div>
                    <div className={`scroll-down-oval-container`}>
                        <div ref={oval} className={`scroll-down-oval`}
                            style={
                                {
                                    backgroundImage: 'url(' + getFileName(iconsImages, 'scroll_oval.svg') + ')'
                                }
                            }>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
   );
};

export default Hero;